/* Mur Cinéma 17/10/2026 | photos de la fiche agrandies au toucher et au clic (Lucas : « les gens essayent de cliquer sur les images pour les mettre en grand »).
   Reprise de la visionneuse OVANEA (assets/mczoom.js, même thème Fullstack), classes mczoom*. Chargée par snippets/mcpc-fiche-compacte.liquid.
   Toucher ou cliquer une photo sans glisser ouvre la visionneuse ; on glisse d'une photo à l'autre, on touche pour zoomer, le bouton retour du téléphone ferme. */
const MAIN = '.product-media-gallery-main-slider';
const LARG = [800, 1200, 1600, 2048];
let depart = null;
let ouvert = null;

const estVideo = (li) => !!li.querySelector('video, iframe, deferred-media, model-viewer, .product-media-video');

function urlLarg(img, w) {
  const u = new URL(img.currentSrc || img.src, location.href);
  u.searchParams.set('width', String(w));
  return u.toString();
}

function photosDe(galerie) {
  const slides = [...galerie.querySelectorAll(MAIN + ' .splide__slide')].filter((li) => !li.classList.contains('splide__slide--clone'));
  const photos = [];
  slides.forEach((li, i) => {
    const img = li.querySelector('.product-media img');
    if (!img || estVideo(li)) return;
    photos.push({ i, img, alt: img.getAttribute('alt') || '' });
  });
  return { slides, photos };
}

function chargerTout(galerie) {
  galerie.querySelectorAll(MAIN + ' img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
}

function svg(d) {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
}

function ouvrir(galerie, indexSlide, depuis) {
  if (ouvert) return;
  const { slides, photos } = photosDe(galerie);
  if (!photos.length) return;
  let k = photos.findIndex((p) => p.i === indexSlide);
  if (k < 0) k = 0;

  const racine = document.createElement('div');
  racine.className = 'mczoom';
  racine.setAttribute('role', 'dialog');
  racine.setAttribute('aria-modal', 'true');
  racine.setAttribute('aria-label', 'Photos du produit en grand');
  racine.innerHTML =
    '<div class="mczoom__haut"><span class="mczoom__cpt" aria-live="polite"></span>' +
    '<button type="button" class="mczoom__fermer" aria-label="Fermer les photos">' + svg('<path d="M6 6l12 12M18 6L6 18"/>') + '</button></div>' +
    '<div class="mczoom__piste"></div>' +
    '<button type="button" class="mczoom__fl mczoom__fl--g" aria-label="Photo précédente">' + svg('<path d="M15 5l-7 7 7 7"/>') + '</button>' +
    '<button type="button" class="mczoom__fl mczoom__fl--d" aria-label="Photo suivante">' + svg('<path d="M9 5l7 7-7 7"/>') + '</button>' +
    '<p class="mczoom__aide">Touchez la photo pour zoomer</p>';
  const piste = racine.querySelector('.mczoom__piste');
  photos.forEach((p, n) => {
    const vue = document.createElement('div');
    vue.className = 'mczoom__vue';
    const im = document.createElement('img');
    im.alt = p.alt;
    im.decoding = 'async';
    if (Math.abs(n - k) > 1) im.loading = 'lazy';
    im.sizes = '100vw';
    im.srcset = LARG.map((w) => urlLarg(p.img, w) + ' ' + w + 'w').join(', ');
    im.src = urlLarg(p.img, 1200);
    im.draggable = false;
    vue.appendChild(im);
    piste.appendChild(vue);
  });

  const cpt = racine.querySelector('.mczoom__cpt');
  const gauche = racine.querySelector('.mczoom__fl--g');
  const droite = racine.querySelector('.mczoom__fl--d');
  const etat = { racine, piste, galerie, slides, photos, k, depuis, historique: false, zoom: null };
  ouvert = etat;

  const maj = () => {
    cpt.textContent = (etat.k + 1) + ' / ' + photos.length;
    gauche.disabled = etat.k <= 0;
    droite.disabled = etat.k >= photos.length - 1;
  };
  const vues = () => piste.children;
  const aller = (n, doux) => {
    n = Math.max(0, Math.min(photos.length - 1, n));
    dezoomer();
    piste.scrollTo({ left: n * piste.clientWidth, behavior: doux ? 'smooth' : 'auto' });
    etat.k = n;
    maj();
  };
  etat.aller = aller;

  function dezoomer() {
    const z = etat.zoom;
    if (!z) return;
    z.vue.classList.remove('is-zoom');
    z.img.style.width = '';
    z.img.style.margin = '';
    z.img.sizes = '100vw';
    z.vue.scrollLeft = 0;
    z.vue.scrollTop = 0;
    etat.zoom = null;
    racine.classList.remove('mczoom--zoom');
  }
  function zoomer(vue, img, x, y) {
    const r = img.getBoundingClientRect();
    if (!r.width) return;
    const f = 2.5;
    const W = r.width * f;
    const H = r.height * f;
    const rx = Math.min(1, Math.max(0, (x - r.left) / r.width));
    const ry = Math.min(1, Math.max(0, (y - r.top) / r.height));
    img.sizes = Math.round(Math.min(250, (W / innerWidth) * 100)) + 'vw';
    vue.classList.add('is-zoom');
    racine.classList.add('mczoom--zoom');
    img.style.width = W + 'px';
    const vw = vue.clientWidth;
    const vh = vue.clientHeight;
    img.style.margin = Math.max(0, (vh - H) / 2) + 'px ' + Math.max(0, (vw - W) / 2) + 'px';
    vue.scrollLeft = Math.max(0, rx * W - (x - vue.getBoundingClientRect().left));
    vue.scrollTop = Math.max(0, ry * H - (y - vue.getBoundingClientRect().top));
    etat.zoom = { vue, img };
  }

  // toucher ou cliquer la photo : zoom / dézoom ; à la souris, la photo zoomée suit le curseur
  let p0 = null;
  const doigts = new Set();
  piste.addEventListener('pointerdown', (e) => { doigts.add(e.pointerId); p0 = doigts.size === 1 ? { x: e.clientX, y: e.clientY, t: Date.now() } : null; });
  etat.lacher = (e) => { doigts.delete(e.pointerId); if (e.type === 'pointercancel') p0 = null; };
  piste.addEventListener('pointerup', (e) => {
    if (!p0 || doigts.size > 1) return;
    const d = Math.hypot(e.clientX - p0.x, e.clientY - p0.y);
    const long = Date.now() - p0.t;
    p0 = null;
    if (d > 10 || long > 500) return;
    const img = e.target.closest('.mczoom__vue img');
    if (!img) { if (!etat.zoom && e.target.classList.contains('mczoom__vue')) fermerUI(); return; }
    if (etat.zoom) dezoomer();
    else zoomer(img.parentElement, img, e.clientX, e.clientY);
    aide.classList.add('is-vu');
  });
  piste.addEventListener('mousemove', (e) => {
    const z = etat.zoom;
    if (!z || matchMedia('(hover: none)').matches) return;
    const r = z.vue.getBoundingClientRect();
    z.vue.scrollLeft = ((e.clientX - r.left) / r.width) * (z.vue.scrollWidth - r.width);
    z.vue.scrollTop = ((e.clientY - r.top) / r.height) * (z.vue.scrollHeight - r.height);
  });
  let attente = 0;
  piste.addEventListener('scroll', () => {
    clearTimeout(attente);
    attente = setTimeout(() => {
      const n = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
      if (n !== etat.k) { etat.k = n; maj(); }
      const v = vues()[n + 1]; if (v) v.firstChild.loading = 'eager';
    }, 60);
  }, { passive: true });

  gauche.addEventListener('click', () => aller(etat.k - 1, true));
  droite.addEventListener('click', () => aller(etat.k + 1, true));
  racine.querySelector('.mczoom__fermer').addEventListener('click', () => fermerUI());
  const aide = racine.querySelector('.mczoom__aide');
  setTimeout(() => aide.classList.add('is-vu'), 2600);

  document.body.appendChild(racine);
  document.documentElement.classList.add('mczoom-ouvert');
  requestAnimationFrame(() => {
    piste.scrollLeft = k * piste.clientWidth;
    maj();
    racine.classList.add('is-ouvert');
    racine.querySelector('.mczoom__fermer').focus({ preventScroll: true });
  });
  try { history.pushState({ mcZoom: 1 }, ''); etat.historique = true; } catch (e) { /* sans historique : on ferme au bouton */ }
}

function fermer() {
  const e = ouvert;
  if (!e) return;
  ouvert = null;
  const p = e.photos[e.k];
  e.racine.remove();
  document.documentElement.classList.remove('mczoom-ouvert');
  const sc = e.galerie.querySelector('slider-component');
  try { if (p && sc && sc.slider && typeof sc.slider.go === 'function') sc.slider.go(p.i); } catch (err) { /* galerie non montée */ }
  if (e.depuis && e.depuis.isConnected) e.depuis.focus({ preventScroll: true });
}

function fermerUI() {
  if (!ouvert) return;
  if (ouvert.historique && history.state && history.state.mcZoom) history.back();
  else fermer();
}

const lacher = (e) => { if (ouvert && ouvert.lacher) { const o = ouvert; setTimeout(() => o.lacher(e), 0); } };
window.addEventListener('pointerup', lacher, true);
window.addEventListener('pointercancel', lacher, true);

window.addEventListener('popstate', () => { if (ouvert) fermer(); });

document.addEventListener('keydown', (e) => {
  if (!ouvert) return;
  if (e.key === 'Escape') { e.preventDefault(); fermerUI(); }
  else if (e.key === 'ArrowLeft') { e.preventDefault(); ouvert.aller(ouvert.k - 1, true); }
  else if (e.key === 'ArrowRight') { e.preventDefault(); ouvert.aller(ouvert.k + 1, true); }
  else if (e.key === 'Tab') {
    const f = [...ouvert.racine.querySelectorAll('button:not([disabled])')].filter((b) => b.offsetParent);
    if (!f.length) return;
    const i = f.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
  }
});

// Galerie : toucher une photo sans glisser l'ouvre. Écoute en capture sur la fenêtre, avant le glisser de la galerie
// (qui annule les clics après un glisser) ; la distance est mesurée ici, un glisser n'ouvre donc rien.
window.addEventListener('pointerdown', (e) => {
  const sl = e.target.closest && e.target.closest(MAIN);
  if (!sl) { depart = null; return; }
  depart = { x: e.clientX, y: e.clientY, t: Date.now() };
  const g = sl.closest('product-media-gallery');
  if (g) chargerTout(g);
}, true);

window.addEventListener('click', (e) => {
  if (!e.target.closest) return;
  const btn = e.target.closest('.mczoom-btn');
  if (btn) {
    const g = btn.closest('product-media-gallery');
    if (!g) return;
    e.preventDefault();
    e.stopPropagation();
    const { slides } = photosDe(g);
    let i = slides.findIndex((li) => li.classList.contains('is-active'));
    if (i < 0) i = 0;
    ouvrir(g, i, btn);
    return;
  }
  const img = e.target.closest(MAIN + ' .product-media img');
  if (!img || !depart) return;
  const d = Math.hypot(e.clientX - depart.x, e.clientY - depart.y);
  const long = Date.now() - depart.t;
  depart = null;
  if (d > 10 || long > 700) return;
  const li = img.closest('.splide__slide');
  const g = img.closest('product-media-gallery');
  if (!li || !g || estVideo(li)) return;
  const { slides } = photosDe(g);
  ouvrir(g, slides.indexOf(li), g.querySelector('.mczoom-btn'));
}, true);

// Loupe posée sur chaque galerie (position absolue : aucune géométrie touchée), et photos différées préchargées.
function equiper(g) {
  const sl = g.querySelector(MAIN);
  if (!sl || sl.querySelector('.mczoom-btn')) return;
  if (!photosDe(g).photos.length) return;
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'mczoom-btn';
  b.setAttribute('aria-label', 'Agrandir la photo');
  b.innerHTML = svg('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M20 20l-4.8-4.8M10.5 7.5v6M7.5 10.5h6"/>');
  sl.appendChild(b);
}
function tout() { document.querySelectorAll('product-media-gallery').forEach(equiper); }
tout();
// la galerie est remplacée au changement de variante (assets/product-media-gallery.js) : on repose la loupe
let attenteMo = 0;
new MutationObserver(() => {
  if (!attenteMo) attenteMo = requestAnimationFrame(() => { attenteMo = 0; tout(); });
}).observe(document.body, { childList: true, subtree: true });

const precharger = () => setTimeout(() => {
  document.querySelectorAll('product-media-gallery').forEach((g) => {
    [...g.querySelectorAll(MAIN + ' img[loading="lazy"]')].slice(0, 2).forEach((img) => { img.loading = 'eager'; });
  });
}, 2500);
if (document.readyState === 'complete') precharger(); else window.addEventListener('load', precharger, { once: true });
